import React from "react";
import { Box, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";

import { BubbleComparisonSettingsStateType, defaultSettings } from "./BubbleComparisonSettings";
import TitleCase from "components/formatting/TitleCase";
import { BubbleChart } from "components/charting/BubbleChart";

interface BubbleComparisonPreviewProps {
  /**
   * State object represented by series of key value pairs,
   * where the key is a string which represents the title of the
   * updatable settings option.
   */
  settingsState: BubbleComparisonSettingsStateType | {};
}

export default function BubbleComparisonPreview(props: BubbleComparisonPreviewProps): React.JSX.Element {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const currentState = {...defaultSettings, ...props.settingsState};

  return (
    <Stack
      sx={{
        gap: 1,
        width: isSmallScreen ? '100%' : '50%'
      }}>
      {currentState.widgetTitle !== 'none' &&
        <Typography
          sx={{ fontSize: "1.2rem", textAlign: `${currentState.widgetTitleAlignment}` }}
          variant="subtitle2">
          <TitleCase text={currentState.widgetTitle} />
        </Typography>
      }
      <Box
        sx={{
          position: "relative",
          minHeight: 300
        }}>
        <BubbleChart
          dataPoints={[
            { x: 25, y: 100, size: 25, name: i18n.t("example-number", {number: 1}), color: theme.colors.namedColors.chart1 },
            { x: 50, y: 200, size: 100, name: i18n.t("example-number", {number: 2}), color: theme.colors.namedColors.chart2 },
            { x: 100, y: 300, size: 50, name: i18n.t("example-number", {number: 3}), color: theme.colors.namedColors.chart3 }
          ]}
          sizeAsPercent={false}
          sizeLabel={i18n.t("widget-types.bubble-comparison.size")}
          xAsPercent={false}
          xLabel={i18n.t("x-axis")}
          yAsPercent={false}
          yLabel={i18n.t("y-axis")}
        />
      </Box>
    </Stack>
  );
}